import { Pagination } from '@shared/components';
import type { HistoryPage } from '../types/agreementTimeline.types';
import { AgreementHistoryEventItem } from './AgreementHistoryEventItem';

interface Props {
    history: HistoryPage;
    currentPage: number;
    onPageChange: (page: number) => void;
}

/** A semantic `<ol>`, not the shared `Table`, is the compliant form here
 *  (docs/features/shared-ui-components.md). API order is never re-sorted. */
export function AgreementHistoryTimeline({ history, currentPage, onPageChange }: Props) {
    if (history.entries.length === 0) {
        return (
            <p className="text-sm text-mp-muted">
                Nothing has been recorded against this agreement yet.
            </p>
        );
    }

    return (
        <>
            <ol aria-label="Agreement history" className="space-y-3">
                {history.entries.map((event) => (
                    <AgreementHistoryEventItem key={event.id} event={event} />
                ))}
            </ol>
            {history.meta.lastPage > 1 && (
                <div className="mt-4">
                    <Pagination
                        currentPage={currentPage}
                        lastPage={history.meta.lastPage}
                        total={history.meta.total}
                        perPage={history.meta.perPage}
                        onPageChange={onPageChange}
                    />
                </div>
            )}
        </>
    );
}
